// Copyright ©️ 2026 eVolve MEP, LLC

import { useEvolveGet } from '@evolvemep/api-ts';

import { DropdownNumberInput } from 'components/Mantine/DropdownNumberInput';
import { BendConduitSelection } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/BendConduitSelection';
import { BendMachineProfileSelect } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/BendMachineProfileSelect';
import { BendTypeSelect } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/BendTypeSelect';
import { useBendCreatorValidationContext } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/useBendCreatorValidationContext';

// in feet
const MATERIAL_STOCK_LENGTH_OPTIONS = [10, 20] as const;

export const BendMachineInfoInputs = () => {
  const {
    data: specificProfile,
    loading: loadingSpecificProfile,
    apiCall: getBenderProfile,
    reset: resetSpecificProfile,
  } = useEvolveGet('shop/fabrication/machineProfile/:machineProfileId/bender');

  const { wrappedGetInputProps } = useBendCreatorValidationContext();

  return (
    <>
      <BendMachineProfileSelect
        getSpecificProfile={({ machineProfileId }) =>
          getBenderProfile({ url: `shop/fabrication/machineProfile/${machineProfileId}/bender` })
        }
        resetSpecificProfile={resetSpecificProfile}
      />
      <BendTypeSelect />
      <BendConduitSelection specificProfile={specificProfile} loadingSpecificProfile={loadingSpecificProfile} />
      <DropdownNumberInput
        {...wrappedGetInputProps('materialStockLength')}
        label="Material Stock Length"
        description="Defines the overall stock length of the material being used to calculate bend values."
        suffix="'"
        decimalScale={2}
        min={0}
        max={30}
        options={MATERIAL_STOCK_LENGTH_OPTIONS}
        required
      />
    </>
  );
};
